module.exports = __webpack_public_path__ + "img/Homepage.805f158b.jpg";